function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#LTC_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 22.701c5.91 0 10.701-4.79 10.701-10.701 0-5.91-4.79-10.701-10.701-10.701C6.09 1.299 1.299 6.089 1.299 12c0 5.91 4.79 10.701 10.701 10.701z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1012 12A11.966 11.966 0 0012.07 0H12zm.203 12.407l-1.249 4.213h6.683a.336.336 0 01.348.325v.11l-.58 2.006a.433.433 0 01-.437.32H6.741l1.714-5.841-1.917.581.435-1.337 1.918-.58 2.412-8.194a.438.438 0 01.435-.32h2.586a.338.338 0 01.35.325v.11l-2.035 6.916 1.918-.581-.407 1.395-1.947.552z",
  fill: "#345D9D"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "LTC_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

function SvgLtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "2a8dbfcc98469343022aa3f2f1425135.svg";
export { SvgLtc as ReactComponent };